// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { number } from "@altostra/type-validations/lib/primitives";

export const isAppsAppGroupIdChartsEmailResult = objectOf({
  daily_email_stats: objectOf({
    delivered_count_by_hour: arrayOf(arrayOf(number)),
    sent_count_by_hour: arrayOf(arrayOf(number)),
    open_count_by_hour: arrayOf(arrayOf(number)),
    click_count_by_hour_including_unsubscribes: arrayOf(arrayOf(number)),
    unsubscribe_count_by_hour: arrayOf(arrayOf(number)),
    spam_report_count_by_hour: arrayOf(arrayOf(number)),
    amp_click_count_by_hour_including_unsubscribes: arrayOf(arrayOf(number)),
    amp_open_count_by_hour: arrayOf(arrayOf(number)),
    machine_open_count_by_hour: arrayOf(arrayOf(number)),
    machine_amp_open_count_by_hour: arrayOf(arrayOf(number)),
    bcc_sent_count_by_hour: arrayOf(arrayOf(number)),
    test_sent_count_by_hour: arrayOf(arrayOf(number)),
    seed_sent_count_by_hour: arrayOf(arrayOf(number)),
    unique_click_count_by_hour: arrayOf(arrayOf(number)),
    unique_open_count_by_hour: arrayOf(arrayOf(number)),
    click_count_by_hour: arrayOf(arrayOf(number)),
    amp_click_count_by_hour: arrayOf(arrayOf(number)),
    bounce_count_by_hour_including_dropped: arrayOf(arrayOf(number)),
  }),
});
